import { render, staticRenderFns } from "./OrderPersons.vue?vue&type=template&id=4955ccf0&scoped=true"
import script from "./OrderPersons.vue?vue&type=script&lang=js"
export * from "./OrderPersons.vue?vue&type=script&lang=js"
import style0 from "./OrderPersons.vue?vue&type=style&index=0&id=4955ccf0&prod&scoped=true&lang=css"
import style1 from "./OrderPersons.vue?vue&type=style&index=1&id=4955ccf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955ccf0",
  null
  
)

export default component.exports